<template>
    <div class="input-element">
      <div class="input-component">
        <label v-if="showLabel && item.label">{{item.label}}
          <span class="field-info" v-if="item.description && showTooltip" v-tooltip="item.description"></span>
        </label>
        <component
          :is="componentType"
          :view="item.view"
          :valueType="item.valueType"
          :valueOptions="item.view.validate_items ? item.view.validate_items : []"
          v-model="value"
          v-on:child-event="onChildEvent()"
        ></component>
      </div>
    </div>
  </template>
  
  <script>
    import FormattedTextInput from '@/components/inputs/inputsTypes/FormattedTextInput'
    import MultiSelectInput from '@/components/inputs/inputsTypes/MultiSelectInput'
    import NumericInput from '@/components/inputs/inputsTypes/NumericInput'
    import RangeInput from '@/components/inputs/inputsTypes/RangeInput'
    import SliderInput from '@/components/inputs/inputsTypes/SliderInput'
    import TextInput from '@/components/inputs/inputsTypes/TextInput'
    import ToggleInput from '@/components/inputs/inputsTypes/ToggleInput'
    import WaveformSelectInput from '@/components/inputs/inputsTypes/WaveformSelectInput'
    import DistributionInput from '@/components/inputs/inputsTypes/DistributionInput'
    import CheckboxInput from '@/components/inputs/inputsTypes/CheckboxInput.vue'

    let componentTypeMap= {
      'formattedText': FormattedTextInput,
      'multiSelectInput': MultiSelectInput,
      'selectInput': MultiSelectInput,
      'distributionInput': DistributionInput,
      'numericInput': NumericInput,
      'rangeInput': RangeInput,
      'rangeSliderInput': SliderInput,
      'sliderInput': SliderInput,
      'textInput': TextInput,
      'toggleInput': ToggleInput,
      'checkboxInput': CheckboxInput,
      'namedXYSeriesInput': WaveformSelectInput
    }

    export default {
      /// This input component can create an input from the different input types defined,
      /// without the need of supplying a template. It receives the item with its information
      /// If showLabel and showTooltip are set to false, it will show a simple input with proper styling.
      name: 'GenericInputContainer',
      props: {
        item: Object,
        showLabel: {
            type: Boolean,
            default: true
        },
        showTooltip: {
            type: Boolean,
            default: true
        },
        showUnits: {
          type: Boolean,
          default: false
        }
      },
      model:{
        prop: 'item',
        event: 'change'
      },
      mounted () {
        this.value = this.item.value
      },
      methods: {
        onChildEvent() {
          this.$emit('child-event');
        }
      },
      computed: {
        value: {
          get(){
            return this.item.value
          },
          set(newValue){
            let updatedItem = {
              ...this.item,
              value: newValue
            }
            this.$emit('change', updatedItem)
          }
        },
        componentType () {
          let comp = ""
          switch (this.item.view.inputType) {
            case 'field':
              if (this.item.valueType === 'string') {
                comp = 'textInput'
              } else {
                comp = 'numericInput'
              }
              comp = 'textInput'
              break
            case 'formattedText':
              comp = 'formattedText'
              break
            case 'slider':
              comp = 'sliderInput'
              break
            case 'fieldRange':
              comp = 'rangeInput'
              break
            case 'sliderRange':
              comp = 'rangeSliderInput'
              break
            case 'toggle':
              comp = 'toggleInput'
              break
            case 'select':
              comp = 'selectInput'
              break
            case 'checkboxes':
              comp = 'multiSelectInput'
              break
            case 'checkbox':
              comp = 'checkboxInput'
              break
            case 'namedXYSeriesInput':
              comp = 'namedXYSeriesInput'
              break
            case 'distributionInput':
              comp = 'distributionInput'
              break
          }
          if(Object.keys(componentTypeMap).includes(comp)){
            return componentTypeMap[comp]
          } else {
            return null
          }
        }
      }
    }
  </script>
  
  <style lang="stylus" scoped>
  .input-element
    display: flex
    width: 100%
    margin-bottom 20px
    padding: 5px 0
    flex: 1 1 0%

    .input-component
      padding: 0 10px; //??
      label
        color: $shuttle-gray
        display: block
        m-font-size(12, 14)
        margin-bottom: 5px
        //text-transform: capitalize
        display flex
        align-items center
        .field-info
          display: inline-block
          m-icon('info', 14)
          margin-left 5px

      >>> .numeric-input,
      >>> .slider-input,
      >>> .range-input,
      >>> .text-input
        input
          border: 1px solid #fff
          border-radius: 4px
          box-shadow: 5px 5px 20px rgba($lynch, 0.25)
          // color: rgba($cloud-burst, 0.5)
          color: $cloud-burst //no?
          m-font-size(13, 16)
          min-height: 32px
          padding: 0 10px

          &:hover
            border-color: $heather

          &:focus
            border-color: $cloud-burst
            color: $cloud-burst
            outline: none

    
  </style>